import {formCopyHelper} from "@/utils";

export default {
    methods: {
        copyMultiFormValueFrom(fieldId) {
            const value = this.fieldIdToValueMaps[fieldId].concat();
            formCopyHelper.setCopyObj({
                projectId: this.projectId,
                fieldId,
                value
            })
        },
        pasteMultiFormValueTo(pastefieldId) {
            const obj = formCopyHelper.getCopyObj();
            if (!obj) {
              alert('It seems you haven\'t copy any form! Nothing pasted.')
              return
            }
            const {projectId, fieldId, value} = obj;
            if (projectId !== this.projectId) {
              alert('The copied source is from another project! Nothing pasted.')
              return;
            }
            if (fieldId !== pastefieldId) {
              alert('The copied source is from another attribute! Nothing pasted.')
              return;
            }
            this.setInputValue(fieldId, value, false);
        }
    },
}
